import Vue from 'vue'
import VueRouter from 'vue-router'
import ViewUI from 'view-design';
Vue.use(ViewUI);
//-----------------------------------------
import Lable from '../views/Lable.vue'
import Home from '../views/Home/index.vue'
import viewProject from '../views/viewProject/index.vue'
import editorProject from '../views/editorProject/index.vue'
import homeProject from '../views/homeProject/index.vue'
import editorMeeting from '../views/editorMeeting/index.vue'
import editorVote from '../views/editorVote/index.vue'
import editorGongshi from '../views/editorGongshi/index.vue'
import editorOffprint from '../views/editorOffprint/index.vue'
import editorPeriodical from '../views/editorPeriodical/index.vue'
import meetingList from '../views/meetingList/index.vue'
import conferenceDetails from '../views/conferenceDetails/index.vue'
import consensusDetails from '../views/consensusDetails/index.vue'
import mediaEditor from '../views/mediaEditor/index.vue'
import gongshiList from '../views/gongshiList/index.vue'
import voteList from '../views/voteList/index.vue'
import offprintList from '../views/offprintList/index.vue'
import meetingDetail from '../views/meetingDetail/index.vue'
import gongshiDetail from '../views/gongshiDetail/index.vue'
import voteDetail from '../views/voteDetail/index.vue'
import viewDrawmarks from '../views/viewDrawmarks/index.vue'
import ExpertDatabase from '../views/ExpertDatabase/index.vue'
import expertDetail from '../views/expertDetail/index.vue'
import expertEditor from '../views/ExpertEditor/index.vue'
import companyDatabase from '../views/companyDatabase/index.vue'
import companydetail from '../views/companyDetail/index.vue'
import foundationdetail from '../views/foundationDetail/index.vue'

import JfoundationDatabase from '../views/JfoundationDatabase/index.vue'
import XfoundationDatabase from '../views/XfoundationDatabase/index.vue'

import booksCollection from '../views/books/booksCollection.vue'
import booksManagement from '../views/books/booksManagement.vue'
import booksArchives from '../views/books/booksArchives.vue'
import booksLiteratureList from '../views/books/booksLiteratureList.vue'
import newSpecialistProfiles from '../views/books/newSpecialistProfiles.vue'
import booksLiterature from '../views/books/booksLiterature.vue'

import foreignerDatabase from '../views/foreignerDatabase/index.vue'
import foreinerDetail from '../views/foreinerDetail/index.vue'
import mediaDatabase from '../views/mediaDatabase/index.vue'
import mediaDetail from '../views/mediaDetail/index.vue'
import companyEditor from '../views/companyEditor/index.vue'
import foundationEditor from '../views/foundationEditor/index.vue'
import foreinerEditor from '../views/foreinerEditor/index.vue'
import zxflist from '../views/zxflist/index.vue'
import zxfEditor from '../views/zxfEditor/index.vue'
import zxfdetail from '../views/zxfdetail/index.vue'

import periodicalList from '../views/periodicalList/index.vue'
import periodicalDetail from '../views/periodicalDetail/index.vue'
import periodicalEditor from '../views/periodicalEditor/index.vue'

import servise from '../views/servise/index.vue'
import serviseList from '../views/serviseList/index.vue'
import details from '../views/details/index.vue'
import wjjzyqdetail from '../views/wjjzyqdetail/index.vue'
import software from '../views/software/index.vue'
// 医学服务
import doctorServe from '../views/doctorServe/index.vue'
import addwjyq from '../views/addwjyq/index.vue'
import CaseLibrary from '../views/CaseLibrary/index.vue'
import Caseeditor from '../views/CaseLibrary/editor.vue'
import Casedetail from '../views/CaseLibrary/detail.vue'


import login from '../entrance/login/index.vue'
import registered from '../entrance/registered/index.vue'
import forgetPwd from '../entrance/forgetPwd/index.vue'
import datum from '../views/PersonalCenter/datum/datum.vue'
import changePassword from '../views/PersonalCenter/changePassword/changePassword.vue'
import collection from '../views/PersonalCenter/collection/index.vue'
import collectionDetails from '../views/PersonalCenter/collection/collectionDetails.vue'
import changePhone from '../views/PersonalCenter/changePhone/changePhone.vue'
import caseAll from '../views/PersonalCenter/caseAll/caseAll.vue'
import caseAllList from '../views/PersonalCenter/caseAll/caseAllList.vue'
import myConcerns from '../views/PersonalCenter/myConcerns/index.vue'
import improveInfo from '../views/improveInfo/index.vue' //微信扫码进来完善信息 
import getPhone from '../views/improveInfo/getPhone.vue' //微信扫码进来完善信息 


import questionnaires from '../views/questionnaires/index.vue' //问卷调查列表
import create from '../views/questionnaires/create/index.vue' //创建问卷调查
import preview from '../views/questionnaires/preview/index.vue' //预览问卷调查 
import check from '../views/questionnaires/check/index.vue' //预览问卷调查
import questionnaireDetails from '../views/questionnaires/questionnaireDetails/index.vue' //预览问卷调查
import answersView from '../views/questionnaires/answersView/index.vue' //个人提交查看问卷
//import fillInQuestionnaires from '../fillInQuestionnaires/index.vue' //填写问卷  


//! 解决路由重复点击
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


const routes = [{
        path: '/',
        redirect: '/login'
    }, {
        path: '/home',
        component: Lable,
        //需要被缓存 
        meta: {
            keepalive: true
        },
        children: [{
                path: '/',
                name: 'Home',
                component: Home
            },
            {
                path: '/viewProject',
                name: 'viewProject',
                component: viewProject
            },
            {
                path: '/editorProject',
                name: 'editorProject',
                component: editorProject
            },
            {
                path: '/homeProject',
                name: 'homeProject',
                component: homeProject,
                //需要被缓存
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/editorMeeting',
                name: 'editorMeeting',
                component: editorMeeting
            },
            {
                path: '/editorVote',
                name: 'editorVote',
                component: editorVote
            },
            {
                path: '/editorGongshi',
                name: 'editorGongshi',
                component: editorGongshi
            },
            {
                path: '/editorOffprint',
                name: 'editorOffprint',
                component: editorOffprint
            },
            {
                path: '/editorPeriodical',
                name: 'editorPeriodical',
                component: editorPeriodical
            },
            {
                path: '/meetingList',
                name: 'meetingList',
                component: meetingList
            },
            {
                path: '/conferenceDetails',
                name: 'conferenceDetails',
                component: conferenceDetails
            },
            {
                path: '/consensusDetails',
                name: 'consensusDetails',
                component: consensusDetails
            },
            {
                path: '/gongshiList',
                name: 'gongshiList',
                component: gongshiList
            },
            {
                path: '/voteList',
                name: 'voteList',
                component: voteList
            },
            {
                path: '/offprintList',
                name: 'offprintList',
                component: offprintList
            },
            {
                path: '/meetingDetail',
                name: 'meetingDetail',
                component: meetingDetail
            },
            {
                path: '/gongshiDetail',
                name: 'gongshiDetail',
                component: gongshiDetail
            },
            {
                path: '/voteDetail',
                name: 'voteDetail',
                component: voteDetail
            },
            {
                path: '/viewDrawmarks',
                name: 'viewDrawmarks',
                component: viewDrawmarks
            },
            {
                path: '/ExpertDatabase',
                name: 'ExpertDatabase',
                component: ExpertDatabase,
                //需要被缓存 
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/expertDetail',
                name: 'expertDetail',
                component: expertDetail
            },
            {
                path: '/expertEditor',
                name: 'expertEditor',
                component: expertEditor
            },
            {
                path: '/companyDatabase',
                name: 'companyDatabase',
                component: companyDatabase,
                //需要被缓存
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/companydetail',
                name: 'companydetail',
                component: companydetail
            },
            {
                path: '/foundationdetail',
                name: 'foundationdetail',
                component: foundationdetail
            },
            {
                path: '/XfoundationDatabase',
                name: 'XfoundationDatabase',
                component: XfoundationDatabase,
                //需要被缓存
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/JfoundationDatabase',
                name: 'JfoundationDatabase',
                component: JfoundationDatabase,
                //需要被缓存
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/booksCollection',
                name: 'booksCollection',
                component: booksCollection,
                //需要被缓存,
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/booksArchives',
                name: 'booksArchives',
                component: booksArchives,
                //需要被缓存, 
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/booksLiteratureList',
                name: 'booksLiteratureList',
                component: booksLiteratureList,
            },
            {
                path: '/newSpecialistProfiles',
                name: 'newSpecialistProfiles',
                component: newSpecialistProfiles,
            },
            {
                path: '/booksManagement',
                name: 'booksManagement',
                component: booksManagement,
                //需要被缓存, 
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/booksLiterature',
                name: 'booksLiterature',
                component: booksLiterature,
                //需要被缓存,
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/foreignerDatabase',
                name: 'foreignerDatabase',
                component: foreignerDatabase,
                //需要被缓存,
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/foreinerDetail',
                name: 'foreinerDetail',
                component: foreinerDetail
            },
            {
                path: '/mediaDatabase',
                name: 'mediaDatabase',
                component: mediaDatabase,
                //需要被缓存
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/mediaDetail',
                name: 'mediaDetail',
                component: mediaDetail
            },
            {
                path: '/companyEditor',
                name: 'companyEditor',
                component: companyEditor
            },
            {
                path: '/foundationEditor',
                name: 'foundationEditor',
                component: foundationEditor
            },
            {
                path: '/foreinerEditor',
                name: 'foreinerEditor',
                component: foreinerEditor
            },
            {
                path: '/mediaEditor',
                name: 'mediaEditor',
                component: mediaEditor
            },
            {
                path: '/zxflist',
                name: 'zxflist',
                component: zxflist,
                //需要被缓存
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/zxfEditor',
                name: 'zxfEditor',
                component: zxfEditor
            },
            {
                path: '/zxfdetail',
                name: 'zxfdetail',
                component: zxfdetail
            },
            {
                path: '/periodicalList',
                name: 'periodicalList',
                component: periodicalList,
                //需要被缓存
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/periodicalDetail',
                name: 'periodicalDetail',
                component: periodicalDetail
            },
            {
                path: '/periodicalEditor',
                name: 'periodicalEditor',
                component: periodicalEditor
            },
            {
                path: '/servise',
                name: 'servise',
                component: servise
            },
            {
                path: '/serviseList',
                name: 'serviseList',
                component: serviseList
            },
            {
                path: '/doctorServe',
                name: 'doctorServe',
                component: doctorServe
            },
            //--
            {
                path: '/datum',
                name: 'datum',
                component: datum
            },
            {
                path: '/changePassword',
                name: 'changePassword',
                component: changePassword
            },
            {
                path: '/collection',
                name: 'collection',
                component: collection,
                //需要被缓存
                meta: {
                    keepalive: true
                },
            },
            //我的合集详情
            {
                path: '/collection/collectionDetails',
                name: 'collectionDetails',
                component: collectionDetails,
                //需要被缓存
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/changePhone',
                name: 'changePhone',
                component: changePhone
            },
            {
                path: '/caseAll',
                name: 'caseAll',
                component: caseAll,
            },
            {
                path: '/caseAllList',
                name: 'caseAllList',
                component: caseAllList
            },
            {
                path: '/myConcerns',
                name: 'myConcerns',
                component: myConcerns,
                meta: {
                    keepalive: true
                },
            },
            //微信扫码 手机号
            {
                path: '/getPhone',
                name: 'getPhone',
                component: getPhone
            },
            //微信扫码登录
            {
                path: '/improveInfo',
                name: 'improveInfo',
                component: improveInfo
            },
            {
                path: '/CaseLibrary',
                name: 'CaseLibrary',
                component: CaseLibrary,
                //需要被缓存
                meta: {
                    keepalive: true
                },
            },
            {
                path: '/Caseeditor',
                name: 'Caseeditor',
                component: Caseeditor
            },
            {
                path: '/Casedetail',
                name: 'Casedetail',
                component: Casedetail
            },
            {
                path: '/addwjyq',
                name: 'addwjyq',
                component: addwjyq
            },
            {
                path: '/questionnaires',
                name: 'questionnaires',
                component: questionnaires,
                //需要被缓存
                meta: {
                    keepalive: true
                },
            },
            //创建问卷调查 
            {
                path: '/questionnaires/create',
                name: 'create',
                component: create,
                //需要被缓存
                meta: {
                    keepalive: true
                },
            },
            //查看问卷调查
            {
                path: '/questionnaires/check',
                name: 'check',
                component: check,
            },
            //问卷详情
            {
                path: '/questionnaires/questionnaireDetails',
                name: 'questionnaireDetails',
                component: questionnaireDetails,
            },
            //个人提交查看问卷
            {
                path: '/questionnaires/answersView',
                name: 'answersView',
                component: answersView,
            },
        ]
    },
    //预览问卷调查  
    {
        path: '/questionnaires/preview',
        name: 'preview',
        component: preview,
        //需要被缓存  
        // meta: {
        //     keepalive: true
        // },
    },
    //登录
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/registered',
        name: 'registered',
        component: registered
    },
    {
        path: '/forgetPwd',
        name: 'forgetPwd',
        component: forgetPwd
    },

    {
        path: '/details',
        name: 'details',
        component: details
    },
    {
        path: '/wjjzyqdetail',
        name: 'wjjzyqdetail',
        component: wjjzyqdetail
    },
    {
        path: '/software',
        name: 'software',
        component: software
    },


]

const router = new VueRouter({
    mode: 'history',
    routes
})

//* 配置加载进度条样式
ViewUI.LoadingBar.config({
    color: '#484c7f',
    height: 3
});

//! 路由 还差微信登录  
router.beforeEach((to, form, next) => {
    //* 加载进度条     
    ViewUI.LoadingBar.finish();

    //* 分享
    if (to.query.projectId != '' && to.query.projectId != undefined && to.query.projectId != null) {
        let sharing = {
            projectId: to.query.projectId,
            teamId: to.query.teamId,
            userId: to.query.userId,
        }
        localStorage.setItem("Sharing", JSON.stringify(sharing));
    }


    //* 判断是否微信扫码登录进入
    if (to.path == '/getPhone' || to.path == '/improveInfo') {
        if (!window.localStorage.getItem('code')) {
            if (!window.localStorage.getItem('token')) {
                router.push('/login');
            } else {
                router.push(form.path);
            }
        } else {
            next()
        }
    }


    //* 判断用户是否登录  && to.path !== '/fillInQuestionnaires'
    if (to.path !== '/login' && to.path !== '/forgetPwd' && to.path !== '/registered') {
        if (!window.localStorage.getItem('token') && !window.localStorage.getItem('code')) {
            router.push('/login');
        } else {
            next()
        }
    } else {
        next()
    }

    //* 微信绑定手机号页面 如果没有oppid就让他返回首页
    if (form.path == '/getPhone' && window.localStorage.getItem('leaving')) {
        router.push('/login');
    } else {
        next()
    }
})

export default router